import { Modal } from 'react-bootstrap';

const SUPPORT_EMAIL = 'support@gridco-op.com';

const FeatureItem = ({ title }) => (
  <div className="d-flex align-items-center gap-2 py-2">
    <i className="fas fa-star text-warning small"></i>
    <span>{title}</span>
  </div>
);

const ProUpgradeModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton  className="border-secondary">
      <Modal.Title className="fw-bold">
        <i className="fas fa-crown text-warning me-2"></i>Upgrade to Pro
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="p-4">
      <p className="text-muted mb-4">
        Unlock the full power of RECOVER with a Pro subscription.
      </p>

      <div className="mb-4 border rounded p-2">
        {/* Add pro features here */}
        <FeatureItem title="Unlimited predictions" />
        <FeatureItem title="Access to utility view" />
        <FeatureItem title="Priority support" />
        <FeatureItem title="Personalized prediction requests and analytics" />
      </div>

      <div className="text-center pt-2">
        <p className="text-muted small mb-3">
          To upgrade to Pro, contact our support team:
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}?subject=Pro Upgrade Inquiry`}
          className="btn btn-warning fw-semibold px-4"
        >
          <i className="fas fa-envelope me-2"></i>{SUPPORT_EMAIL}
        </a>
      </div>
    </Modal.Body>
  </Modal>
);

export default ProUpgradeModal;
